jQuery(document).ready(function(){
	jQuery(".collection-items").slick({
		  slidesToShow: 3,
          slidesToScroll: 1,
         autoplay: false,
          arrows: true,
		  centerMode: true,
  		  autoplaySpeed: 5000,
		  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

	}); 
});

jQuery(document).ready(function(){
	jQuery(".testimonial-items").slick({
		  slidesToShow: 1,
          slidesToScroll: 1,
         autoplay: false,
          arrows: true,
		  centerMode: true,
  		  autoplaySpeed: 5000,

	}); 
});


jQuery(document).ready(function(){
	jQuery(".img-slides-cus").slick({
		  slidesToShow: 3,
          slidesToScroll: 1,
         autoplay: false,
          arrows: false,
		  centerMode: true,
          dots: true,
  		  autoplaySpeed: 5000,

	}); 
});

jQuery(document).ready(function(){
    jQuery(".testimonial-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        centerMode: true,
        dots: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});



jQuery(document).ready(function($) {
        // Tab button click event
        $('.tab-button').on('click', function() {
            var target = $(this).data('target');
            
            // Remove active class from all buttons and content sections
            $('.tab-button').removeClass('active');
            $('.tab-content-sec').removeClass('active');

            // Add active class to the clicked button and the target content section
            $(this).addClass('active');
            $('#' + target).addClass('active');
        });
    });


jQuery(document).ready(function($) {
      // Detect scroll event on the window
      $(window).on("scroll", function() {
        // Get the current scroll position
        var scrollTop = $(this).scrollTop();

        // Calculate the rotation angle based on scroll position
        // Modify the divisor to control rotation speed
        var rotateAngle = scrollTop / 5;

        // Apply the rotation to the image
        $(".rotate-on-scroll").css("transform", "rotate(" + rotateAngle + "deg)");
      });
    });

// ************************** Show more Filter *******************************

// jQuery(document).ready(function ($) {
//     const details = $("#FacetsWrapperDesktop details");
//     const showMoreButton = $('<button class="filter-button-toggle show-more">Show More</button>');
//     const showLessButton = $('<button class="filter-button-toggle show-less">Show Less</button>').hide();

//     // Initially show only the first 8 details
//     details.slice(7).hide();

//     // Append the buttons to the wrapper
//     $("#FacetsWrapperDesktop").append(showMoreButton).append(showLessButton);

//     // Show more button click event
//     showMoreButton.click(function (e) {
//         e.preventDefault(); // Prevent default button behavior
//         details.show(); // Show all details
//         showMoreButton.hide(); // Hide Show More button
//         showLessButton.show(); // Show Show Less button
//     });

//     // Show less button click event
//     showLessButton.click(function (e) {
//         e.preventDefault(); // Prevent default button behavior
//         details.slice(7).hide(); // Hide details after the first 4
//         showLessButton.hide(); // Hide Show Less button
//         showMoreButton.show(); // Show Show More button
//     });
// });



// ************************** Menu Tabs *******************************

jQuery(document).ready(function($) {
  // When a tab is clicked
  $('.menu-tab').click(function() {
    var tabId = $(this).data('tab');
    
    // Remove active class from all tabs and tab-content
    $('.menu-tab').removeClass('menu-active');
    $('.menu-tab-content').removeClass('menu-active');
    
    // Add active class to the clicked tab and corresponding content
    $(this).addClass('menu-active');
    $('.' + tabId).addClass('menu-active');
  });
});



// ************************** Menu Hide show *******************************

jQuery(document).ready(function($) {
    // Initially hide the .section-sections element
    $('.section-sections--27564267733150__custom_liquid_8BcYde-padding').hide();

    // Toggle visibility of the .section-sections element when clicking on #HeaderMenu-shop
    $('#HeaderMenu-shop, #HeaderDrawer-shop').click(function() {
        $('.section-sections--27564267733150__custom_liquid_8BcYde-padding').stop(true, true).slideToggle(300); // Smooth toggle
        $(this).toggleClass("active");
    });

    // Hide the section if the user clicks outside of #HeaderMenu-shop or the section
    $(document).click(function(event) {
        if (!$(event.target).closest('#HeaderMenu-shop, .section-sections--27564267733150__custom_liquid_8BcYde-padding, #HeaderDrawer-shop').length) {
            $('.section-sections--27564267733150__custom_liquid_8BcYde-padding').stop(true, true).slideUp(300); // Smooth hide
          $('#HeaderMenu-shop, #HeaderDrawer-shop').removeClass("active");
        }
    });

    // Hide the section when the page is scrolled
    // $(window).scroll(function() {
    //     $('.section-sections--27564267733150__custom_liquid_8BcYde-padding').stop(true, true).slideUp(300); // Smooth hide
    // });
});


jQuery(document).ready(function($) {
    // Initially hide the .section-sections element
    $('.section-sections--27564267733150__custom_liquid_VknzYk-padding').hide();

    // Toggle visibility of the .section-sections element when clicking on #HeaderMenu-shop
    $('#HeaderMenu-live-pets').click(function() {
        $('.section-sections--27564267733150__custom_liquid_VknzYk-padding').stop(true, true).slideToggle(300); // Smooth toggle
        $(this).toggleClass("active");
    });

    // Hide the section if the user clicks outside of #HeaderMenu-shop or the section
    $(document).click(function(event) {
        if (!$(event.target).closest('#HeaderMenu-live-pets, .section-sections--27564267733150__custom_liquid_VknzYk-padding').length) {
            $('.section-sections--27564267733150__custom_liquid_VknzYk-padding').stop(true, true).slideUp(300); // Smooth hide
          $('#HeaderMenu-live-pets').removeClass("active");
        }
    });

    // Hide the section when the page is scrolled
    $(window).scroll(function() {
        $('.section-sections--27564267733150__custom_liquid_VknzYk-padding').stop(true, true).slideUp(300); // Smooth hide
      $('#HeaderMenu-live-pets').removeClass("active");
    });
}); 



// ************************** Review tabs *******************************

jQuery(document).ready(function($) {
    // Log to confirm the document is ready
    console.log("Document is ready");

    // Select the review widget div using the parent of the specified class
    var reviewWidget = $("#judgeme_product_reviews").parent();
    
    // Log the review widget to check if it's found
    console.log("Review widget found:", reviewWidget.length > 0 ? "Yes" : "No");

    // Select the destination div
    var targetDiv = $('#content--tab_3rJi8E--template--27564271632542__custom_tabs_itRfmy');
    
    // Log the target div to check if it's found
    console.log("Target div found:", targetDiv.length > 0 ? "Yes" : "No");

    // If both elements exist, move the review widget under the target div
    if (reviewWidget.length > 0 && targetDiv.length > 0) {
        reviewWidget.appendTo(targetDiv);
        console.log("Review widget moved successfully.");
    } else {
        console.log("One or both elements were not found. Check the selectors.");
    }
});















